import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@homeexchange/design';

const NewUserLabel = ({ label }) => <Tag color="primary-info" text={label} />;

NewUserLabel.propTypes = {
    label: PropTypes.string
};

export default NewUserLabel;
